var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenubtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.27,
    height: 23.491,
    viewBox: "0 0 28.27 23.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-button-of-three-horizontal-lines",
    transform: "translate(0 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M25.534,6H2.736A2.641,2.641,0,0,0,0,8.517a2.641,2.641,0,0,0,2.736,2.517h22.8A2.641,2.641,0,0,0,28.27,8.517,2.641,2.641,0,0,0,25.534,6Z",
    fill: "#0b2740"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M25.534,50H2.736a2.526,2.526,0,1,0,0,5.034h22.8a2.526,2.526,0,1,0,0-5.034Z",
    transform: "translate(0 -34.771)",
    fill: "#0b2740"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M25.534,94H2.736a2.526,2.526,0,1,0,0,5.034h22.8a2.526,2.526,0,1,0,0-5.034Z",
    transform: "translate(0 -69.543)",
    fill: "#0b2740"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenubtn);
export default __webpack_public_path__ + "static/media/menubtn.39e71a4157dd72a89cc3c7825b0fbb3f.svg";
export { ForwardRef as ReactComponent };